import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Modal, Svg } from '@hopskipdrive/react-components';
import { useCreateInvoiceGroup } from '@rideiq/organizers/pages/BillingInvoiceGroups';
import { ButtonLink } from '@rideiq/shared/components';
import { Button } from '@rideiq/shared/components/Button';
import { Text } from '@rideiq/shared/components/Text';
import { colorTokens } from '@rideiq/shared/components/variables';

import { InvoiceGroupForm, InvoiceGroupFormData } from '../InvoiceGroupForm';
import { invoiceGroupSchema } from '../InvoiceGroupForm/validationSchema';
import { CloseButton } from '../styles';

const defaultValues: InvoiceGroupFormData = {
  name: '',
  poNumber: '',
};

export const CreateInvoiceGroupModal = () => {
  const { isSubmitting, handleSubmit } = useCreateInvoiceGroup();
  const methods = useForm<InvoiceGroupFormData>({
    defaultValues,
    resolver: yupResolver(invoiceGroupSchema),
  });

  return (
    <Modal open={true} data-testid="create-invoice-group-modal">
      <Modal.Title>
        <Box display="flex" alignItems="flex-start" justifyContent="space-between">
          <Box display="flex" flexDirection="column" gap="6px">
            <Text variant="h1" fontWeight={700}>
              Create Invoice Group
            </Text>
            <Text textColor={colorTokens.text.medium}>
              Create groups to organize riders according to your internal accounting requirements.
            </Text>
          </Box>
          <CloseButton to=".." aria-label="Close" type="button">
            <Svg height="20px" icon="close-outlined" />
          </CloseButton>
        </Box>
      </Modal.Title>
      <Modal.Content>
        <FormProvider {...methods}>
          <InvoiceGroupForm formId="create-invoice-group-form" onSubmit={methods.handleSubmit(handleSubmit)} />
        </FormProvider>
      </Modal.Content>
      <Modal.Actions>
        <ButtonLink color="tertiary" to=".." disabled={isSubmitting}>
          Never mind
        </ButtonLink>
        <Button
          color="primary"
          type="submit"
          form="create-invoice-group-form"
          loading={isSubmitting}
          sx={{ height: '36px', minWidth: '90px' }}
        >
          Create
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
